async function r({file:r,crop:e}){if(!r||!e)throw new Error("Missing file or crop");return await createImageBitmap(r,e.x,e.y,e.width,e.height)}export{r as default};
